import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import './License.css';

const LicensePageComponent = () => {
    const [license, setLicense] = useState('');

    useEffect(() => {
        fetch('/license.md')
            .then(response => response.text())
            .then(text => {
                setLicense(text);
            })
            .catch(error => {
                console.error('Error loading license:', error);
            });
    }, []);

    return (
        <div className="licenseContainer">
            <header className="licenseHeader">
                <h1>License and Terms of Use</h1>
                <p>Last updated: July 2025</p>
            </header>
            <div className="licenseContent">
                <ReactMarkdown>{license}</ReactMarkdown>
            </div>
        </div>
    );
};

export default LicensePageComponent;